<template>
  <div class="foundation">
    <dna-wrapper>
      <!-- 搜索栏 -->
      <dna-search-bar></dna-search-bar>
      <!-- 区块概览 -->
      <dna-info-block
        class="info-block"
      ></dna-info-block>
      <!-- 表格 -->
      <dna-foundation-table></dna-foundation-table>
    </dna-wrapper>
  </div>
</template>

<script>
import dnaSearchBar from "@/components/SearchBar/SearchBar.vue";
import dnaInfoBlock from "@/components/InfoBlock/InfoBlock.vue";
import dnaFoundationTable from "@/components/FoundationTable/FoundationTable.vue";
import UTIL from "@/util/util.js";
export default {
  data() {
    return {
      
    }
  },
  components: {
    dnaSearchBar,
    dnaInfoBlock,
    dnaFoundationTable
  }
};
</script>

<style lang="less" scoped>
@import url("./Foundation.less");
</style>